import React from "react";

import CampaignList from "@/features/campaigns/shared/components/CampaignList";
import DirectMailCampaignCard from "./DirectMailCampaignCard";
import type { DirectMailCampaignCardData } from "./directMailCampaignCardTypes";

type DirectMailCampaignListProps = {
  campaigns?: DirectMailCampaignCardData[];
  isLoading?: boolean;
  searchValue?: string;
  participantId?: string | number;
};

const DirectMailCampaignList = ({
  campaigns = [],
  isLoading,
  searchValue = "",
  participantId,
}: DirectMailCampaignListProps) => (
  <div className="post-card-campaign-available">
    <div className="yet-to-join-campaigns">
      <CampaignList
        campaigns={campaigns}
        isLoading={isLoading}
        searchValue={searchValue}
        emptyMessage="No direct mail campaigns are currently available."
        renderCard={(campaign) => (
          <DirectMailCampaignCard
            campaign={campaign}
            isLoading={isLoading}
            participantId={participantId}
          />
        )}
      />
    </div>
  </div>
);

export default React.memo(DirectMailCampaignList);
